import * as Yup from 'yup';

const INITIAL_VALUES_ADD_ADMIN = {
    firstName: '',
    lastName: '',
    email: '',
    cellNumber: ''
};

const VALIDATION_SCHEMA_ADD_ADMIN = Yup.object().shape({
    firstName: Yup.string().required("Enter first name"),
    lastName: Yup.string().required("Enter last name"),
    email: Yup.string().required("Enter an email id").email("Invalid Email")
});


export { INITIAL_VALUES_ADD_ADMIN, VALIDATION_SCHEMA_ADD_ADMIN };
